import { ApiClientReturnType, TableDataType } from '~/types'
import api from '../../api/http-common'
import { MilkMoneyOptionsType } from './dashboard'

// Manager Profile

const getProfileData = ():ApiClientReturnType<ManagerProfileType> =>
  api.post('/manager/profile')

const getFarmersIndex = (data?):ApiClientReturnType<ManagerUsersTableType> =>
  api.post('/manager/profile/farmers/index', data)

const getCollectionPointsIndex = (data?):ApiClientReturnType<CollectionPointsTableType> =>
  api.post('/manager/profile/collection-points/index', data)

// Deliveries

const getDeliveriesIndexData = (): ApiClientReturnType<MilkMoneyOptionsType> =>
  api.post('/milk-money/temp/milk-deliveries/get-index-data')

const getDeliveriesIndex = (data?) =>
  api.post('/milk-money/temp/milk-deliveries/index', data)

// Qualities

const getMilkTestsIndexData = (): ApiClientReturnType<MilkMoneyOptionsType> =>
  api.post('/milk-money/temp/milk-qualities/get-index-data')

const getMilkTestsIndex = (data?) =>
  api.post('/milk-money/temp/milk-qualities/index', data)

// Milk Payments

const getMilkInvoicesIndex = (data?) =>
  api.post('/milk-money/temp/milk-invoices/index', data)

const getMilkInvoicePreviewPdf = (id: string) =>
  api.post(`/milk-money/temp/milk-invoices/${id}/preview/pdf`)

export const ManagerService = {
  getProfileData,
  getFarmersIndex,
  getCollectionPointsIndex,
  getDeliveriesIndexData,
  getDeliveriesIndex,
  getMilkTestsIndexData,
  getMilkTestsIndex,
  getMilkInvoicesIndex,
  getMilkInvoicePreviewPdf
}

type ManagerUsersTableType = TableDataType<ManagerUserType>
type CollectionPointsTableType = TableDataType<CollectionPointType>

export interface ManagerUserType {
  id: string;
  evsNumber: string;
  agisId: string;
  companyName: string;
  managerId: string;
  farmerId: string;
  streetName: string;
  streetNumber: string;
  zip: string;
  city: string;
  canton: string | null;
  country: string | null;
}

export interface ManagerProfileType {
  manager: Manager;
}

export interface CollectionPointType {
  id: string;
  evsNumber: string;
  agisId: string;
  companyName: string;
  managerId: string;
  farmerId: string;
}

export interface Manager {
  id: string;
  agisId: string;
  membershipStatusId: number;
  name: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  burNumber: string;
  languageId: number;
  phonePrefix: number;
  phoneNumber: string;
  digitalPayment: number;
  membershipApplicationDate: Date;
  membershipApplicationFile: null;
  cancellationDate: Date;
  createdAt: Date;
  updatedAt: Date;
  taxNumber: null;
  mobilePrefix: null;
  mobileNumber: string | null;
  associations: any[];
  status: number;
  languages: any[];
  addressableId: string;
  streetName: string;
  streetNumber: string;
  zip: string;
  city: string;
  countryId: number;
  localDistrict: null;
  stateId: null;
  districtId: null;
  agricultureDistrictId: null;
  latitude: string;
  longitude: string;
  administrativeDistrictId: null;
  cantonId: null;
  country: Country;
  state: null;
  district: null;
  agricultureDistrict: null;
  phonePrefixCountry: PhonePrefixCountry;
  mobilePrefixCountry: null;
}

export interface Country {
  id: number;
  iso: string;
  label: string;
}

export interface PhonePrefixCountry {
  id: number;
  phoneCode: string;
  label: string;
}
